import React, { Component, PropTypes } from 'react';

import { carHireOptionPropType } from 'components/CarHire/shapes';
import BookPrice from 'components/BookPrice/BookPrice';
import LinkButton from 'components/LinkButton/LinkButton';
import HireCarInfo from 'components/CarHire/HireCarInfo';

import './CarHireOption.desktop.scss';
import './CarHireOption.mobile.scss';

export default class CarHireOption extends Component {
  static propTypes = {
    carHireOption: carHireOptionPropType.isRequired,
    numberOfDays: PropTypes.number.isRequired,
    onSelectClick: PropTypes.func.isRequired,
  };

  handleSelectClick = (event) => {
    const { carHireOption, onSelectClick } = this.props;

    event.preventDefault();
    onSelectClick(carHireOption);
  };

  render() {
    const { carHireOption, numberOfDays } = this.props;

    return (
      <div className="car-hire-option">
        <HireCarInfo carHireOption={carHireOption} />
        <div className="car-hire-option__price" >
          <BookPrice
            price={carHireOption.getIn(['pricing', 'webPrice'])}
            divisor={numberOfDays}
            suffix="per day"
            hasSmallSuffix
          />
        </div>
        <div className="car-hire-option__select">
          <LinkButton color="blue" onClick={this.handleSelectClick}>Select</LinkButton>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/CarHire/CarHireOption.jsx
 **/